import axios from "axios";
import { PATH } from "../PATH";
import api from "./api";

const allFilesPath = (page: string) =>
  page ? `/all-files/?page=${page}` : "/all-files/";

const allPostsPath = (page: string) =>
  page ? `/all-posts/?page=${page}` : "/all-posts/";

const services = {
  getFiles: async (page: string) => {
    return api
      .get(allFilesPath(page))
      .then((data: any) => data)
      .catch((err: any) => {
        console.log(err);
        throw err;
      });
  },
  deleteFile: async (file: string) => {
    return api
      .get(`/delete-files/?file=${file}`)
      .then((data: any) => data)
      .catch((err: any) => {
        console.log(err);
        throw err;
      });
  },
  getFileContentBase64: (fileKey: string | undefined) => {
    return axios
      .get(`${PATH.baseApi}/get-file-content-base64/?file_key=${fileKey}`)
      .then((response) => {
        if (response.data && response.data.file_content_base64) {
          return response.data.file_content_base64;
        } else {
          throw new Error(
            "A resposta da API não contém o conteúdo do arquivo em base64."
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching file content:", error);
        throw error;
      });
  },
  deletePublishedFile: async (file: string) => {
    return api
      .get(`/delete-posts/?file=${file}`)
      .then((data: any) => data)
      .catch((err: any) => {
        console.log(err);
        throw err;
      });
  },
  downloadFiles: async (file: string) => {
    return api
      .get("/download-files/", {
        params: { directory: "templates", file },
      })
      .then((data: any) => data)
      .catch((err: any) => {
        console.log(err);
        throw err;
      });
  },
  getCertificateStatus: async () => {
    return api
      .get("/certificate-status/")
      .then((data: any) => data)
      .catch((err: any) => {
        console.log(err);
        throw err;
      });
  },
  doPost: async (body: FormData) => {
    return api
      .post("/do-post/", body)
      .then((response: any) => response)
      .catch((err: any) => {
        console.log(err);
        throw err;
      });
  },
  getAllPosts: async (page: string, auth: boolean) => {
    const path = allPostsPath(page);
    const req = auth
      ? api.get(path)
      : axios.get(`${PATH.baseApi}${path}`);
    return req
      .then((data: any) => data)
      .catch((err: any) => {
        console.log(err);
        throw err;
      });
  },
  getPublic: async (body: any, page?: string) => {
    const queryString = [
      body.date.from && `start_date=${body.date.from}`,
      body.date.to && `end_date=${body.date.to}`,
      body.post_type &&
        Array.isArray(body.post_type) &&
        body.post_type.length > 0 &&
        body.post_type.map((type: string) => `post_type=${type}`),
      body.post_code &&
        body.post_code.length > 0 &&
        `post_code=${body.post_code}`,
      body.words &&
        Array.isArray(body.words) &&
        body.words.length > 0 &&
        body.words.map((word: string) => `words=${word}`),
      body.exact_words === true && `exact_words=${body.exact_words}`,
      body.words_contain === true && `words_contain=${body.words_contain}`,
      page && `page=${page}`,
    ]
      .filter(Boolean)
      .flat()
      .join("&");
    const url = `${PATH.baseApi}/search-files/${
      queryString.length > 0 ? "?" + queryString : ""
    }`;
    return axios.get(url).catch((err: any) => {
      console.log(err);
      throw err;
    });
  },
};

export default services;
